module.exports = __webpack_public_path__ + "img/nature-7.bdeb60cc.jpg";